export enum PageSubscriptionStatisticsQueriedActionTypes {
  GET_PAGE_SUBSCRIPTION_STATISTICS_QUERIED_REQUEST = 'page-subscription-statistics-queried/GET_PAGE_SUBSCRIPTION_STATISTICS_QUERIED_REQUEST',
  GET_PAGE_SUBSCRIPTION_STATISTICS_QUERIED_SUCCESS = 'page-subscription-statistics-queried/GET_PAGE_SUBSCRIPTION_STATISTICS_QUERIED_SUCCESS',
  GET_PAGE_SUBSCRIPTION_STATISTICS_QUERIED_ERROR = 'page-subscription-statistics-queried/GET_PAGE_SUBSCRIPTION_STATISTICS_QUERIED_ERROR',
}
